import './index.scss';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import { SearchType } from '~/routes/content_library/providers/enums';
import Permissions from '~/settings/permissions';
const SearchTypeRadioButton = (props) => {
    const { searchType, setSearchType } = props;
    return (React.createElement("div", { className: 'search-radios' },
        React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.SEARCH_CLAUSES] },
            React.createElement("input", { type: 'radio', className: 'input radio', id: 'clause-search-toggle', "data-testid": 'clause-search-toggle', name: 'search-type', onChange: () => setSearchType(SearchType.Clauses), checked: searchType === SearchType.Clauses }),
            React.createElement("label", { className: 'input-label', htmlFor: 'clause-search-toggle' }, "Clauses")),
        React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.SEARCH_DOCUMENTS] },
            React.createElement("input", { type: 'radio', className: 'input radio', id: 'document-search-toggle', "data-testid": 'document-search-toggle', name: 'search-type', onChange: () => setSearchType(SearchType.Documents), checked: searchType === SearchType.Documents }),
            React.createElement("label", { className: 'input-label', htmlFor: 'document-search-toggle' }, "Documents"))));
};
export default SearchTypeRadioButton;
